export default __webpack_public_path__ + "static/media/pdf.27bdc56d.svg";